import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import moment from 'moment';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});


const ModalDocumentManagement = ({ closeModal, openModal, id_estudio, listarDocumentos, documentInformation, toggle }) => {

    //Datos Basicos
    const [descripcion, setDescripcion] = React.useState(null);
    const [dateDocument, setDateDocument] = React.useState(null);
    const [classDocument, setClassDocument] = React.useState(1);
    const [type, setTypeDocument] = React.useState(1);
    const [version, setVersion] = React.useState(null);
    const [fileDocument, setFileDocument] = React.useState(null);

    //Fechas de Aprobaciones
    const [dateDocumentSubmission, setDateDocumentSubmission] = React.useState(null);
    const [dateDocumentApprove, setDateDocumentApprove] = React.useState(null);
    const [dateDocumentApproveInvima, setDateDocumentApproveInvima] = React.useState(null);
    const [dateDocumentApproveSponsor, setDateDocumentApproveSponsor] = React.useState(null);
    const [disabledDate, setDisabledDate] = React.useState(false);//Solo se habilita esta opcion si ya todas las fechas estan registradas

    //Loader
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    const alertModal = (success, message) => {
        if (success == true) {
            setAlertColorModal("success");
        }
        else {
            setAlertColorModal("danger");
        }
        setAlerShowModal(true);
        setAlertMessageModal(message);
    }

    React.useEffect(() => {

        if (documentInformation == null) {
            clearDocumentInformation();
        }
        else {
            verifyDocumentInformation();
        }

    }, []);

    const clearDocumentInformation = () => {
        setDescripcion(null);
        setDateDocument(null);
        setClassDocument(1);
        setTypeDocument(1);
        setVersion(null);
        setDateDocumentSubmission(null);
        setDateDocumentApprove(null);
        setDateDocumentApproveInvima(null);
        setDateDocumentApproveSponsor(null);
    }

    const verifyDocumentInformation = () => {
        setDescripcion(documentInformation.descripcion);
        setDateDocument(new Date(documentInformation.fecha_doc));
        setClassDocument(parseInt(documentInformation.clase));
        setTypeDocument(parseInt(documentInformation.tipo));
        setVersion(documentInformation.version);
        setDateDocumentSubmission(documentInformation.fecha_sometimiento != null ? new Date(documentInformation.fecha_sometimiento) : null);
        setDateDocumentApprove(documentInformation.fecha_aprobacion != null ? new Date(documentInformation.fecha_aprobacion) : null);
        setDateDocumentApproveInvima(documentInformation.fecha_apro_invima != null ? new Date(documentInformation.fecha_apro_invima) : null);
        setDateDocumentApproveSponsor(documentInformation.fecha_apro_patrocinador != null ? new Date(documentInformation.fecha_apro_patrocinador) : null);


        if (documentInformation.editable == true) {
            setDisabledDate(false);
        }
        else {
            setDisabledDate(true);
        }
    }

    const onOk = () => {
        setAlerShowModal(false);
        if (colorAlertModal == "success") {
            closeModal();
        }
    }

    const addDocument = async () => {
        if (descripcion == null) {
            alert("Descripcion es Requerida");
            return;
        }
        if (dateDocument == null) {
            alert("Fecha del Documento es requerido");
            return;
        }
        if (classDocument == null) {
            alert("La clase del documento es requerida");
            return;
        }
        if (type == null) {
            alert("El tipo de documento es requerido");
            return;
        }
        if (version == null) {
            alert("La version es requerida");
            return;
        }
        if (fileDocument == null) {
            alert("El Adjunto del Documento es requerido");
            return;
        }

        let dataDocument = new FormData();
        dataDocument.append('id_estudio', id_estudio);
        dataDocument.append('descripcion', descripcion);
        dataDocument.append('fecha_doc', moment(dateDocument).format("YYYY-MM-DD HH:mm:ss"));
        dataDocument.append('clase', classDocument);
        dataDocument.append('tipo', type);
        dataDocument.append('version', version);
        dataDocument.append('archivo', fileDocument);

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}gestion-documental/create`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataDocument
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                closeModal();
                listarDocumentos();
                toggle(classDocument.toString());
            }
            else {
                throw new Error("Ha ocurrido un error enviando el documento");
            }
        }).catch(err => {
            alertModal(false, "Ha ocurrido un error enviando el documento");
        });
    }

    const updateDocument = async () => {
        if (descripcion == null) {
            alert("Descripcion es Requerida");
            return;
        }

        let dataDocument =
        {
            id_est_gestd: parseInt(documentInformation.id_est_gestd),
            fecha_sometimiento: dateDocumentSubmission != null ? moment(dateDocumentSubmission).format("YYYY-MM-DD HH:mm:ss") : null,
            fecha_aprobacion: dateDocumentApprove != null ? moment(dateDocumentApprove).format("YYYY-MM-DD HH:mm:ss") : null,
            fecha_apro_invima: dateDocumentApproveInvima != null ? moment(dateDocumentApproveInvima).format("YYYY-MM-DD HH:mm:ss") : null,
            fecha_apro_patrocinador: dateDocumentApproveSponsor != null ? moment(dateDocumentApproveSponsor).format("YYYY-MM-DD HH:mm:ss") : null,
            descripcion: descripcion
        }

        await fetch(`${process.env.REACT_APP_PUBLIC_URL}gestion-documental/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataDocument)
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                closeModal();
                listarDocumentos();
            }
            else {
                throw new Error("Ha ocurrido un error actualizando el documento");
            }
        }).catch(err => {
            closeModal();
            alertModal(false, "Ha ocurrido un error actualizando el documento");
        });
    }

    React.useEffect(() => {

    }, []);

    return (
        <div>
            <Modal
                open={openModal}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            {documentInformation == null ?
                                <h5 className="bold-text">Agregar Documento</h5> :
                                <h5 className="bold-text">Editar Documento</h5>
                            }


                        </div>

                        <Row>
                            <Col md={4}>
                                <TextField
                                    label="Descripcion"
                                    value={descripcion}
                                    disabled={disabledDate}
                                    onChange={(event) => {
                                        setDescripcion(event.target.value);
                                    }}
                                    style={{
                                        minWidth: '200px',
                                    }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                />
                            </Col>
                            <Col md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            variant="inline"
                                            style={{ minWidth: '200px', }}
                                            value={dateDocument}
                                            onChange={(date) => {
                                                setDateDocument(date);
                                            }}
                                            disabled={documentInformation != null ? true : false}
                                            label="Fecha del Documento"
                                            format="DD/MM/YYYY"
                                            animateYearScrolling
                                            className='medical-material-form__field material-form__label'
                                            InputLabelProps={{
                                                style: { color: '#646777' }
                                            }}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col md={4}>
                                <TextField
                                    id="standard-select-class"
                                    select
                                    label="Clase"
                                    value={classDocument}
                                    onChange={(event) => {
                                        setClassDocument(event.target.value);
                                    }}
                                    disabled={documentInformation != null ? true : false}
                                    style={{ minWidth: '200px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Consentimiento Informado
                                    </MenuItem>
                                    <MenuItem key={1} value={2}>
                                        Cuestionarios de Estudio
                                    </MenuItem>
                                    <MenuItem key={1} value={3}>
                                        Manual de Laboratorio
                                    </MenuItem>
                                    <MenuItem key={1} value={4}>
                                        Manual del Investigador
                                    </MenuItem>
                                    <MenuItem key={1} value={5}>
                                        Material de Reclutamiento
                                    </MenuItem>
                                    <MenuItem key={1} value={6}>
                                        Protocolo
                                    </MenuItem>
                                </TextField>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md={4}>
                                <TextField
                                    id="standard-select-tipo-documento"
                                    select
                                    label="Tipo de Documento"
                                    value={type}
                                    disabled={documentInformation != null ? true : false}
                                    onChange={(event) => {
                                        setTypeDocument(event.target.value);
                                    }}
                                    style={{ minWidth: '200px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                    <MenuItem key={1} value={1}>
                                        Original
                                    </MenuItem>
                                    <MenuItem key={1} value={2}>
                                        Enmienda
                                    </MenuItem>
                                </TextField>
                            </Col>
                            <Col md={4}>
                                <TextField
                                    id="standard-select-version"
                                    label="Version"
                                    value={version}
                                    disabled={documentInformation != null ? true : false}
                                    onChange={(event) => {
                                        setVersion(event.target.value);
                                    }}
                                    style={{ minWidth: '200px', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }
                                    }}
                                >
                                </TextField>
                            </Col>
                        </Row>

                        {
                            documentInformation != null ? <>
                                <br /><br />
                                <Row>
                                    <Col md={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <ThemeProvider theme={defaultMaterialTheme}>
                                                <KeyboardDatePicker
                                                    variant="inline"
                                                    style={{ minWidth: '200px', }}
                                                    value={dateDocumentSubmission}
                                                    onChange={(date) => {
                                                        setDateDocumentSubmission(date);
                                                    }}
                                                    disabled={disabledDate}
                                                    label="Fecha de Sometimiento"
                                                    format="DD/MM/YYYY"
                                                    animateYearScrolling
                                                    className='medical-material-form__field material-form__label'
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col md={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <ThemeProvider theme={defaultMaterialTheme}>
                                                <KeyboardDatePicker
                                                    variant="inline"
                                                    style={{ minWidth: '200px', }}
                                                    value={dateDocumentApprove}
                                                    onChange={(date) => {
                                                        setDateDocumentApprove(date);
                                                    }}
                                                    disabled={disabledDate}
                                                    label="Fecha de Aprobación"
                                                    format="DD/MM/YYYY"
                                                    animateYearScrolling
                                                    className='medical-material-form__field material-form__label'
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            </ThemeProvider>

                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col md={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <ThemeProvider theme={defaultMaterialTheme}>
                                                <KeyboardDatePicker
                                                    variant="inline"
                                                    style={{ minWidth: '200px', }}
                                                    value={dateDocumentApproveInvima}
                                                    onChange={(date) => {
                                                        setDateDocumentApproveInvima(date);
                                                    }}
                                                    disabled={disabledDate}
                                                    label="Fecha Aprobación Invima"
                                                    format="DD/MM/YYYY"
                                                    animateYearScrolling
                                                    className='medical-material-form__field material-form__label'
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                    <Col md={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils} >
                                            <ThemeProvider theme={defaultMaterialTheme}>
                                                <KeyboardDatePicker
                                                    variant='inline'
                                                    style={{ minWidth: '200px', }}
                                                    value={dateDocumentApproveSponsor}
                                                    onChange={(date) => {
                                                        setDateDocumentApproveSponsor(date);
                                                    }}
                                                    disabled={disabledDate}
                                                    label="Fecha Aprobación Patrocinador"
                                                    format="DD/MM/YYYY"
                                                    animateYearScrolling
                                                    className='medical-material-form__field material-form__label'
                                                    InputLabelProps={{
                                                        style: { color: '#646777' }
                                                    }}
                                                />
                                            </ThemeProvider>
                                        </MuiPickersUtilsProvider>
                                    </Col>
                                </Row>

                            </> : null
                        }




                        <br />
                        <Row>
                            <Col md={12}>
                                <input
                                    disabled={documentInformation != null ? true : false}
                                    type="file"
                                    onChange={(e) => {
                                        setFileDocument(e.target.files[0]);
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {documentInformation !=
                            null ?
                            <Button
                                disabled={disabledDate}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    updateDocument();
                                }}
                            >
                                Actualizar
                            </Button>
                            :
                            <Button
                                disabled={false}
                                style={{ marginTop: 10, marginRight: 10 }}
                                variant="contained"
                                className="btn btn-primary btn-sm text-white"
                                onClick={() => {
                                    addDocument();
                                }}
                            >
                                Crear
                            </Button>
                        }
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOk(false)}
                toggle={() => setAlerShowModal(false)}
            />
        </div>
    );
};
export default ModalDocumentManagement;
